// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-title[data-v-14705beb] {\n  font-size: 16px;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 18px;\n}\n.image-container[data-v-14705beb] {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 20px;\n}\n.image-container .image[data-v-14705beb] {\n  width: 120px;\n  height: 120px;\n  margin: 0 20px 20px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
